export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        const categoryLinks = ele.querySelectorAll('[data-category]');
        Array.from(categoryLinks).forEach(element => {
            element.addEventListener('click', trackClick);
        });

        function trackClick(event) {
            trackingservice.trackLaterObj({
                analyticsName: 'navigation.filter-by-category.click',
                stringValue: `location:bapfront,category:${event.target.getAttribute(
                    'data-category'
                )}`,
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/trackBapBrowseCategoryClick.js